/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Exercise_Sheet_Frames_AltInputs */

const en_us2_exercise_sheet_frames_alt = /** @type {(inputs: Exercise_Sheet_Frames_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: start and finish positions`)
};

const pt_br2_exercise_sheet_frames_alt = /** @type {(inputs: Exercise_Sheet_Frames_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: posição inicial e posição final`)
};

const es_419_exercise_sheet_frames_alt = /** @type {(inputs: Exercise_Sheet_Frames_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: posición inicial y posición final`)
};

const pt_pt2_exercise_sheet_frames_alt = /** @type {(inputs: Exercise_Sheet_Frames_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: posição inicial e posição final`)
};

const fr_fr2_exercise_sheet_frames_alt = /** @type {(inputs: Exercise_Sheet_Frames_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} : position de départ et position finale`)
};

const de_de2_exercise_sheet_frames_alt = /** @type {(inputs: Exercise_Sheet_Frames_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: Start- und Endposition`)
};

const it_it2_exercise_sheet_frames_alt = /** @type {(inputs: Exercise_Sheet_Frames_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: posizione iniziale e finale`)
};

/**
* | output |
* | --- |
* | "{name}: start and finish positions" |
*
* @param {Exercise_Sheet_Frames_AltInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_frames_alt = /** @type {((inputs: Exercise_Sheet_Frames_AltInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Frames_AltInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_frames_alt(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_frames_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_frames_alt(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_frames_alt(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_frames_alt(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_frames_alt(inputs)
	return en_us2_exercise_sheet_frames_alt(inputs)
});
export { exercise_sheet_frames_alt as "exercise-sheet.frames_alt" }